export default "__VITE_ASSET__DQ8bcAWK__"